<span container="body" placement="left auto"
    [ngbTooltip]="disableDownloadButton() ? 'Certificate download not available to this learning record':''">
    <button type="button" class="btn btn-sm btn-outline-light fw-semibold"
        [disabled]="disableDownloadButton() || downloading()" (click)="downloadCertificate()"><span
            *ngIf="downloading()">
            <ui-spinner size="sm" class="me-1"></ui-spinner>
        </span><ui-streamline-icon [slIcon]="{name: 'interface-download-button-2', theme: 'micro-bold', size: 'sm'}"
            class="me-1 m-transformY-1"></ui-streamline-icon>Download PDF Certificate</button>
</span>